import moment from 'moment';

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const formatDate = (value: string) => {
  return moment(value).format(DEFAULT_DATE_FORMAT);
};
